import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";

const LANG_BASE = "vessel-call.port-services.fields";

const rejectionOnlySchema = () =>
  z.object({
    files: z.any().optional(),
    rejectionReason: z
      .string()
      .min(
        1,
        i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.rejection-reason`),
        }),
      )
      .max(
        1000,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.rejection-reason`),
          required_error: i18n.t("form-validation.required", {
            label: i18n.t(`${LANG_BASE}.rejection-reason`),
          }),
          max: 1000,
        }),
      ),
  });

export const rejectionSchema = () => rejectionOnlySchema().merge(notificationSchema);

export type RejectionSchema = z.infer<ReturnType<typeof rejectionSchema>>;
